import { Component } from '@angular/core';

@Component({
  selector: 'brt-pulse-circle',
  templateUrl: './pulse-circle.component.html',
  styleUrls: ['./pulse-circle.component.scss']
})
export class PulseCircleComponent {

}
